import { Transforms, Element, Node } from 'slate';
import {
  PARAGRAPH_DEFINITIONS,
  QUOTE_DEFINITIONS,
  QUOTE_SOURCE_DEFINITIONS,
  QUOTE_TEXT_DEFINITIONS,
} from '@xingternal/content-editor-plugin-helpers';

const withQuote = (editor) => {
  const { normalizeNode } = editor;

  editor.normalizeNode = ([node, path]) => {
    if (Element.isElement(node) && node.type === QUOTE_DEFINITIONS.type) {
      if (node.children.length < 1) {
        const quote = {
          type: QUOTE_TEXT_DEFINITIONS.type,
          children: [{ text: '' }],
        };
        Transforms.insertNodes(editor, quote, { at: path.concat(0) });
      }

      if (node.children.length < 2) {
        const source = {
          type: QUOTE_SOURCE_DEFINITIONS.type,
          children: [{ text: '' }],
        };
        Transforms.insertNodes(editor, source, { at: path.concat(1) });
      }

      if (node.children.length >= 3) {
        Transforms.setNodes(
          editor,
          { type: PARAGRAPH_DEFINITIONS.type },
          { at: path.concat(2) }
        );
        Transforms.liftNodes(editor, { at: path.concat(2) });
      }

      for (const [child, childPath] of Node.children(editor, path)) {
        let type =
          childPath[1] === 0
            ? QUOTE_TEXT_DEFINITIONS.type
            : QUOTE_SOURCE_DEFINITIONS.type;

        if (child.type !== type) {
          Transforms.setNodes(editor, { type }, { at: childPath });
        }
      }
    }

    // Fall back to the original `normalizeNode` to enforce other constraints.
    return normalizeNode([node, path]);
  };

  return editor;
};

export { withQuote };
